import { render, staticRenderFns } from "./ContestJudgeSectionComponent.vue?vue&type=template&id=2fda235c"
import script from "./ContestJudgeSectionComponent.vue?vue&type=script&lang=js"
export * from "./ContestJudgeSectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestJudgeSectionComponent.vue?vue&type=style&index=0&id=2fda235c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports